import React from 'react';

import FoundItLowerButton from '../../../../../../components/found-it-lower-button/found-it-lower-button';
import ProductDescription from '../../../../../../components/product-description/product-description';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../../../components/quantity-disclaimer/quantity-disclaimer';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price';

import { getNormalizedProductType } from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';

import './product-list-staggered-card-axle.scss';

interface ProductListStaggeredCardAxleProps {
  label: string;
  onQuantityChange: (e: Event, number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListStaggeredCardAxle(
  props: ProductListStaggeredCardAxleProps
) {
  const { label, onQuantityChange, product, quantity, totalQuantity } = props;

  const { code, size } = product || {};

  const productType = getNormalizedProductType(product?.productType);

  return (
    <div styleName="container">
      <strong styleName="label">{label}</strong>
      <ProductDescription code={code} size={size} />

      <div styleName="price-qty-container">
        <div styleName="price-container">
          <ProductListCardPrice
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />
          <FoundItLowerButton
            productItem={{
              product: product,
              quantity: quantity,
              totalQuantity: totalQuantity
            }}
          />
        </div>
        <ProductQuantity
          defaultValue={2}
          id="quantity"
          isHorizontal
          max={2}
          onBlur={onQuantityChange}
          onChange={onQuantityChange}
          showLabel
          value={quantity}
        />
      </div>
      <QuantityDisclaimer
        productType={productType}
        quantity={quantity}
        styleName="quantity-disclaimer"
      />
    </div>
  );
}

export default ProductListStaggeredCardAxle;
